<template>
  <div class="main-container">
    <div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => (toast = val)"
      />
      <pop-up-message
        v-if="showTickMsg"
        :message="`FBP Eligibility Configure has been successfully updated.`"
        btnText="Back"
        @back="backfrompopup()"
      />

      <tl-header type="h1">
        <div>FBP Component Mapping</div>
      </tl-header>
      <tl-select
        label="Selected Slab"
        name="Selected Slab"
        :disable="true"
        v-model="name"
      />
      <br />
      <tl-select
        v-if="formData.SalaryComponentLegalEntity"
        label="Selected Component"
        name="Selected Component"
        placeholder="Select Component"
        :disable="true"
        v-model="formData.SalaryComponentLegalEntity.name"
      />

      <div class="row mt-4">
        <div class="col-12">
          <div class="label text-secondary">Allow Lower Declaration</div>
        </div>
        <div class="col-12 addflex margintop-16">
          <tl-radio
            label="Yes"
            name="isAllowLowerDec"
            id="yes_isAllowLowerDec"
            :value="true"
            v-model="formData.allow_lower_declaration"
            @change="onAllowLowerDeclarationChange(formData.allow_lower_declaration)"
          />
          <tl-radio
            label="No"
            name="isAllowLowerDec"
            id="no_isAllowLowerDec"
            :value="false"
            v-model="formData.allow_lower_declaration"
            @change="onAllowLowerDeclarationChange(formData.allow_lower_declaration)"
          />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <div class="label text-secondary">
            Allow Carry Forward of Low/Excess Bills
          </div>
        </div>
        <div class="col-12 addflex margintop-16">
          <tl-radio
            label="Yes"
            name="isAllowCarryBills"
            id="yes_isAllowCarryBills"
            :value="true"
            v-model="formData.allow_carry_forward_of_low_excess_bills"
            @change="onCarryForwardBillsChange(formData.allow_carry_forward_of_low_excess_bills)"
          />
          <tl-radio
            label="No"
            name="isAllowCarryBills"
            id="no_isAllowCarryBills"
            :value="false"
            v-model="formData.allow_carry_forward_of_low_excess_bills"
            @change="onCarryForwardBillsChange(formData.allow_carry_forward_of_low_excess_bills)"
          />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <div class="label text-secondary">
            Allow Carry Forward of Eligibility
          </div>
        </div>
        <div class="col-12 addflex margintop-16">
          <tl-radio
            label="Yes"
            name="isAllowCarryEligibility"
            id="yes_isAllowCarryEligibility"
            :value="true"
            v-model="formData.allow_carry_forward_of_eligibility"
            @change="onCarryForwardEligibilityChange(formData.allow_carry_forward_of_eligibility)"
          />
          <tl-radio
            label="No"
            name="isAllowCarryEligibility"
            id="no_isAllowCarryEligibility"
            :value="false"
            :v-model="formData.allow_carry_forward_of_eligibility"
            @change="onCarryForwardEligibilityChange(formData.allow_carry_forward_of_eligibility)"
          />
        </div>
      </div>

      <!-- <div class="row mt-4">
        <div class="col-12">
          <div class="label text-secondary">Allow Adhoc Full Claim</div>
        </div>
        <div class="col-12 addflex margintop-16">
          <tl-radio
            label="Yes"
            name="isAllowAdhocFullClaim"
            id="yes_isAllowAdhocFullClaim"
            :value="true"
            v-model="formData.allow_adhoc_full_claims"
            @change="onAllowAdhocClaimsChange(formData.allow_adhoc_full_claims)"
          />
          <tl-radio
            label="No"
            name="isAllowAdhocFullClaim"
            id="no_isAllowAdhocFullClaim"
            :value="false"
            v-model="formData.allow_adhoc_full_claims"
            @change="onAllowAdhocClaimsChange(formData.allow_adhoc_full_claims)"
          />
        </div>
      </div> -->

      <!-- <div class="row mt-4">
        <div class="col-12">
          <div class="label text-secondary">Allow Annual Claim</div>
        </div>
        <div class="col-12 addflex margintop-16">
          <tl-radio
            label="Yes"
            name="isAllowAnnualClaim"
            id="yes_isAllowAnnualClaim"
            :value="true"
            v-model="formData.allow_annual_claim"
            @change="onAllowAnnualClaimChange(formData.allow_annual_claim)"
          />
          <tl-radio
            label="No"
            name="isAllowAnnualClaim"
            id="no_isAllowAnnualClaim"
            :value="false"
            v-model="formData.allow_annual_claim"
            @change="onAllowAnnualClaimChange(formData.allow_annual_claim)"
          />
        </div>
      </div> -->

      <div class="row mt-4">
        <div class="col-3">
          <tl-select
            label="Process type"
            labelText="processType"
            placeholder="Select Type"
            :options="processTypeList"
            v-model="formData.process_type"
            @change="(value) => (formData.process_type = value)"
          ></tl-select>
        </div>
      </div>

      <!-- <div class="row mt-4">
        <div class="col-12">
          <div class="label text-secondary">Auto Claim</div>
        </div>
        <div class="col-12 addflex margintop-16">
          <tl-radio
            label="Yes"
            name="isAutoClaim"
            id="yes_isAutoClaim"
            :value="true"
            v-model="formData.allow_auto_claim"
            @change="onAllowAutoClaimChange(formData.allow_auto_claim)"
          />
          <tl-radio
            label="No"
            name="isAutoClaim"
            id="no_isAutoClaim"
            :value="false"
            v-model="formData.allow_auto_claim"
            @change="onAllowAutoClaimChange(formData.allow_auto_claim)"
          />
        </div>
      </div>

      <div class="mt-4">
        <tl-select
          class="text-capital"
          label="Select Month"
          name="Select Month"
          placeholder="Select Month"
          :options="months"
          v-model="formData.months"
          @change="(val) => {formData.months = val;}"
        />
      </div>

      <div class="mt-4">
        <tl-select
          class="text-capital"
          label="Select Day"
          name="Select Day"
          placeholder="Select Day"
          :options="days"
          v-model="formData.days"
          @change="(val) => {formData.days = val;}"
        />
      </div>

      <div class="mt-4">
        <tl-select
          label="Excluded Component"
          name="excluded_component"
          placeholder="Select Excluded Component"
          labelText="name"
          :multiple="true"
          :options="fbpComponentList"
          v-model="formData.excluded_component"
          @change="(val) => {formData.excluded_component = val;}"
        />
      </div> -->
    </div>

    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous" />
          <btn text="Save" type="primary" @click="saveData" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "FbpMapping",
  data() {
    return {
      toast: false,
      errmsg: "",
      role: "",
      name: "",
      showTickMsg: false,
      fbpComponentList: [],
      criteriaData: [],
      exclusiveArray: [],
      fbpEligibilityValue: false,
      formData: {},
      //processTypeList: ["Monthly", "Quarterly", "Bi-Annually", "Annually"],
      processTypeList: ["Monthly"],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
    };
  },
  computed: {
    ...mapState("onboard/fbpEligibilityConfig", {
      designationsDataAll: (state) => state.entityWiseData,
      isFetching: (state) => state.isFetching,
      isSaving: (state) => state.isSaving,
      isDeleting: (state) => state.isDeleting,
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
      record: "onboard/fbpEligibilityConfig/record",
    }),
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: (state) => state.id,
    }),
    editMode() {
      return this.$store.getters["onboard/fbpEligibilityConfig/editMode"];
    },
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.fbpEligibilityValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.fbpEligibilityValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },

  mounted() {
    this.getFbpComponents();
    this.getOrgLeIdList();
  },
  activated() {
    this.getFbpComponents();
    this.toast = false;

    if (this.editMode) {
      this.formData = this.record;
      if (this.formData.fbp_criterias === "GRADES") {
        this.name = this.formData.grade.name;
      } else if (this.formData.fbp_criterias === "LEVEL") {
        this.name = this.formData.Level.name;
      } else if (this.formData.fbp_criterias === "LOCATION") {
        this.name = this.formData.LocationLegalEntity.name;
      } else {
        this.name = this.formData.FbpCtcSlab.slab_name;
      }
      if (this.formData.calculation_type === "Flat") {
        this.formData.calculation_type = "FLAT";
      } else if (this.formData.calculation_type === "% Of CTC") {
        this.formData.calculation_type = "PERCENTAGE_OF_CTC";
      } else if (this.formData.calculation_type === "% Of Basic") {
        this.formData.calculation_type = "PERCENTAGE_OF_BASIC";
      } else if(this.formData.calculation_type === "% Of Gross") {
        this.formData.calculation_type = "PERCENTAGE_OF_GROSS";
      }

      if (
        this.formData.process_type === "MONTHLY" &&
        this.formData.process_type !== null
      ) {
        return (this.formData.process_type = "Monthly");
      } else if (
        this.formData.process_type === "QUARTERLY" &&
        this.formData.process_type !== null
      ) {
        return (this.formData.process_type = "Quarterly");
      } else if (
        this.formData.process_type === "BI_ANNUALLY" &&
        this.formData.process_type !== null
      ) {
        return (this.formData.process_type = "Bi-Annually");
      } else if (
        this.formData.process_type === "ANNUALLY" &&
        this.formData.process_type !== null
      ) {
        return (this.formData.process_type = "Annually");
      }
    } else {
      this.refresh();
    }
  },
  methods: {
    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    ...mapActions("onboard/fbpEligibilityConfig/", {
      act_fetch: "fetchAll",
      act_update: "create",
      act_getData: "fetchData",
      act_changeEditMode: "changeEditMode",
    }),
    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:", org);
      //console.log("Le ID", le);
      let bodyParams = {};
      let data = await this.getOrgLeList({
        data: {
          ...bodyParams,
        },
      });
      this.role = data.data.user.userRole;
      this.fbpEligibilityValue = data.data.user.permissions.fbpEligibilityConfig
        ? true
        : false;
      //console.log("PL-3406", data);
    },

    onAllowLowerDeclarationChange(allowLowerDeclarationFlag) {
      if (allowLowerDeclarationFlag == "true") {
        this.formData.allow_lower_declaration = true;
      } else {
        this.formData.allow_lower_declaration = false;
      }
    },

    onCarryForwardBillsChange(carryForwardBillsFlag) {
      if (carryForwardBillsFlag == "true") {
        this.formData.allow_carry_forward_of_low_excess_bills = true;
      } else {
        this.formData.allow_carry_forward_of_low_excess_bills = false;
      }
    },

    onCarryForwardEligibilityChange(carryForwardEligibilityFlag) {
      if (carryForwardEligibilityFlag == "true") {
        this.formData.allow_carry_forward_of_eligibility = true;
      } else {
        this.formData.allow_carry_forward_of_eligibility = false;
      }
    },

    onAllowAdhocClaimsChange(allowAdhocClaimsFlag) {
      if (allowAdhocClaimsFlag == "true") {
        this.formData.allow_adhoc_full_claims = true;
      } else {
        this.formData.allow_adhoc_full_claims = false;
      }
    },

    onAllowAnnualClaimChange(allowAnnualClaimFlag) {
      if (allowAnnualClaimFlag == "true") {
        this.formData.allow_annual_claim = true;
      } else {
        this.formData.allow_annual_claim = false;
      }
    },

    onAllowAutoClaimChange(allowAutoClaimFlag) {
      if (allowAutoClaimFlag == "true") {
        this.formData.allow_auto_claim = true;
      } else {
        this.formData.allow_auto_claim = false;
      }
    },

    /* function to go to next page */
    saveData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
        }
      });
    },

    async getFbpComponents() {
      let fbpComponentsData = [];

      try {
        const res = await this.act_fetch(this.le_id);
        fbpComponentsData = res.data.payload.data;
        this.fbpComponentList = [];
        for (let i = 0; i < fbpComponentsData.length; i++) {
          if (
            fbpComponentsData[i].id !==
            this.formData.SalaryComponentLegalEntity.id
          ) {
            this.fbpComponentList.push(fbpComponentsData[i]);
          }
        }
      } catch (err) {
        //console.log(err);
      }
    },

    async performAction() {
      let excludedComponent = [];
      this.formData.excluded_component && this.formData.excluded_component.map((el) => {
        let obj = {
          name: el.name,
          id: el.id,
        };
        excludedComponent.push(obj);
      });
      //console.log(excludedComponent, "line no 123");
      if (this.formData.calculation_type === "Flat") {
        this.formData.calculation_type = "FLAT";
      } else if (this.formData.calculation_type === "% Of CTC") {
        this.formData.calculation_type = "PERCENTAGE_OF_CTC";
      } else if (this.formData.calculation_type === "% Of Basic") {
        this.formData.calculation_type = "PERCENTAGE_OF_BASIC";
      } else if(this.formData.calculation_type === "% Of Gross") {
        this.formData.calculation_type = "PERCENTAGE_OF_GROSS";
      }
      // if (this.formData.process_type === "Monthly") {
      //   this.formData.process_type = "MONTHLY";
      // } else if (this.formData.process_type === "Quarterly") {
      //   this.formData.process_type = "QUARTERLY";
      // } else if (this.formData.process_type === "Bi-Annually") {
      //   this.formData.process_type = "BI_ANNUALLY";
      // } else {
      //   this.formData.process_type = "ANNUALLY";
      // }
      this.formData.process_type = "MONTHLY";
      let data = {
        fbp_component_id: this.formData.SalaryComponentLegalEntity.id,
        calculation_type: this.formData.calculation_type,
        value: this.formData.value,
        le_id: this.le_id,
        allow_lower_declaration: Boolean(this.formData.allow_lower_declaration),
        allow_carry_forward_of_low_excess_bills: Boolean(this.formData.allow_carry_forward_of_low_excess_bills),
        allow_carry_forward_of_eligibility: Boolean(this.formData.allow_carry_forward_of_eligibility),
        //allow_adhoc_full_claims: Boolean(this.formData.allow_adhoc_full_claims),
        //allow_annual_claim: Boolean(this.formData.allow_annual_claim),
        //allow_auto_claim: Boolean(this.formData.allow_auto_claim),
        process_type: this.formData.process_type,
        //months: this.formData.months.substring(0, 3).toLowerCase(),
        //days: this.formData.days.substring(0, 3).toLowerCase(),
        //excluded_component: excludedComponent,
      };
      if (this.formData.fbp_criterias === "GRADES") {
        try {
          data.fbp_criterias = this.formData.fbp_criterias;
          data.fbp_salary_grade_id = this.formData.fbp_salary_grade_id;
          let formData = [data];
          const res = await this.act_update({ data: [...formData] });
          if (res) {
            this.showTickMsg = true;
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      } else if (this.formData.fbp_criterias === "LOCATION") {
        try {
          data.fbp_criterias = this.formData.fbp_criterias;
          data.fbp_location_id = this.formData.fbp_location_id;
          let formData = [data];
          const res = await this.act_update({ data: [...formData] });
          if (res) {
            this.showTickMsg = true;
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      } else if (this.formData.fbp_criterias === "LEVEL") {
        try {
          data.fbp_criterias = this.formData.fbp_criterias;
          data.fbp_level_id = this.formData.fbp_level_id;
          let formData = [data];
          const res = await this.act_update({ data: [...formData] });
          if (res) {
            this.showTickMsg = true;
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      } else {
        try {
          data.fbp_ctc_slab_id = this.formData.fbp_ctc_slab_id;
          let formData = [data];
          const res = await this.act_update({ data: [...formData] });
          if (res) {
            this.showTickMsg = true;
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      }
    },

    backfrompopup() {
      this.showTickMsg = false;
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/fbpEligibilityConfig`,
      });
    },

    /* function to go to previous page */
    previous() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/fbpEligibilityConfig`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.noData {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .text {
    color: #858585;
    font-size: 14px;
  }
}

.addnewbtn {
  float: right;
  margin-left: 8px;
}

.text-capital {
  text-transform: capitalize;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  border-color: #f5c2c7;
}
</style>
